import type Keycloak from 'keycloak-js';
import type { User } from '../types/user';

function resolveClientRoles(keycloak: Keycloak): string[] {
  const clientId = keycloak.clientId;

  if (!clientId) {
    return [];
  }

  return keycloak.resourceAccess?.[clientId]?.roles ?? [];
}

export function mapKeycloakUser(keycloak: Keycloak): User {
  const token = keycloak.tokenParsed;

  if (!token?.sub) {
    throw new Error('Keycloak token is missing a subject claim');
  }

  const name =
    token.name ?? token.preferred_username ?? token.given_name ?? 'User';

  return {
    id: token.sub,
    name: typeof name === 'string' ? name : 'User',
    email: typeof token.email === 'string' ? token.email : '',
    roles: resolveClientRoles(keycloak),
  };
}
